import { lightColorPalette, darkColorPalette, extraLightColorPalette } from '@pearsontechnology/aero-components';

const darkPage = {
  ...darkColorPalette,
};

const lightPage = {
  ...lightColorPalette,
};

const extraLightPage = {
  ...extraLightColorPalette,
};

const themes = {
  dark: {
    themeId: 'dark',
    ...darkPage,
  },
  light: {
    themeId: 'light',
    ...lightPage,
  },
  'extra-light': {
    themeId: 'extra-light',
    ...extraLightPage,
  },
};

export default themes;
